import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();
export { AuthContext };

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch (error) {
      console.error("Failed to parse user from localStorage", error);
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');
      localStorage.removeItem('token');
      setUser(null);
    } finally {
      setLoading(false); // Set loading to false after checking
    }

    // Listen for auth changes
    const handleAuthChange = () => {
      const newUser = localStorage.getItem('user');
      setUser(newUser ? JSON.parse(newUser) : null);
    };

    window.addEventListener('authChange', handleAuthChange);
    return () => window.removeEventListener('authChange', handleAuthChange);
  }, []);

  // Update user data (including profile completion status)
  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    window.dispatchEvent(new Event('authChange'));
  };

  // Check if user is authenticated
  const isAuthenticated = () => {
    return !!user;
  };

  // Check if user profile is complete
  const isProfileComplete = () => {
    return user?.profileCompletion?.isComplete || false;
  };

  // Get profile completion percentage
  const getProfileCompletionPercentage = () => {
    return user?.profileCompletion?.completionPercentage || 0;
  };

  // Hàm đăng xuất
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.dispatchEvent(new Event('authChange'));
  };

  const value = {
    user,
    loading, // Export the loading state
    updateUser,
    logout,
    isAuthenticated: isAuthenticated(),
    isProfileComplete: isProfileComplete(),
    profileCompletionPercentage: getProfileCompletionPercentage()
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
